'use strict';

var _ = require('lodash');
var CalibrationAnalysisToolbarController = function CalibrationAnalysisToolbarController($rootScope, $scope, searchCriteriaConstantsService, dataRetrieverConstantsService, searchResultMarketsService, configurationService) {
  var NON_CODE_SHARE_MARKETS = _.chain(configurationService.getNonCodeShareMarkets()).map(function (item) {
    return item.origin + '-' + item.destination;
  }).value();
  $scope.screen = dataRetrieverConstantsService.CALIBRATION_ANALYSIS_SCREEN;
  $scope.initialScreen = searchCriteriaConstantsService.CALIBRATION_ANALYSIS;
  $scope.triggerSearch = function () {
    var marketList = _.filter(searchResultMarketsService.getMarkets(), function (market) {
      return _.includes(NON_CODE_SHARE_MARKETS, market.value);
    });
    _.set($scope.screenState, 'searchResultMarkets', marketList);
    $rootScope.$broadcast('search-criteria:searchChangeEvent');
  };
};
CalibrationAnalysisToolbarController.$inject = ['$rootScope', '$scope', 'SearchCriteriaConstantsService', 'DataRetrieverConstantsService', 'SearchResultMarketsService', 'ConfigurationService'];
module.exports = CalibrationAnalysisToolbarController;